import * as types from '../actions/types'
import createReducer from '../createReducer'

const initialCvUsersListsState = {
  lastUpdatedUsersLists: '',
  isFetchingUsersLists: false,
  fetchUsersListsSuccess: false,
  fetchUsersListsFailure: false,
  fetchUsersListsError: '',

  lists: {},
}

export default createReducer(initialCvUsersListsState, {
  [types.FETCH_USERS_LISTS_REQUEST](state, action) {
    const newState = Object.assign({}, state, {
      isFetchingUsersLists: true,
      fetchUsersListsSuccess: false,
      fetchUsersListsFailure: false,
      fetchUsersListsError: '',
    })
    return newState
  },
  [types.FETCH_USERS_LISTS_SUCCESS](state, action) {
    let lists = {}
    for (let key of Object.keys(action.lists)) {
      lists[key] = action.lists[key]
    }

    const newState = Object.assign({}, state, {
      isFetchingUsersLists: false,
      fetchUsersListsSuccess: true,
      fetchUsersListsFailure: false,
      fetchUsersListsError: '',
      lastUpdatedUsersLists: Date.now(),
      lists,
    })
    return newState
  },
  [types.FETCH_USERS_LISTS_FAILURE](state, action) {
    const newState = Object.assign({}, state, {
      isFetchingUsersLists: false,
      fetchUsersListsSuccess: false,
      fetchUsersListsFailure: true,
      fetchUsersListsError: action.error,
    })
    return newState
  },
})
